import UpsellModal from './UpsellModal';

export default UpsellModal;
